import moment from 'moment';
import React from "react";
import { useSelector } from 'react-redux';
// import LeadColumnFields from '../../CustomColumn/LeadColumns.json'

const scaleMap = {
    million: 1_000_000,
    billion: 1_000_000_000
};

const universalSorter = (valueA, valueB, profile) => {
    const extractText = (val) => {
        if (React.isValidElement(val)) {
            val = val.props?.children ?? '';
        }
        if (Array.isArray(val)) {
            val = val.map(child => {
                if (React.isValidElement(child)) {
                    return child.props?.children ?? '';
                }
                return child;
            }).join(' ');
        }
        if (typeof val === 'number') return val;
        if (typeof val === 'string') {
            const trimmed = val.trim();
            if (profile?.dateFormate && moment(trimmed, profile.dateFormate, true).isValid()) {
                return moment(trimmed, profile.dateFormate, true).toDate().getTime();
            }
            const scaleMatch = trimmed.match(/(\d+(?:\.\d+)?)\s*(million|billion)/i);
            if (scaleMatch) {
                const number = parseFloat(scaleMatch[1]);
                const unit = scaleMatch[2].toLowerCase();
                return number * scaleMap[unit];
            }
            const cleaned = trimmed
                .replace(/^[^\d-]+/, '')
                .replace(/,/g, '')
                .replace(/\s+/g, '');
            const numberMatch = cleaned.match(/^(\d+(\.\d+)?)/);
            if (numberMatch) {
                return parseFloat(numberMatch[0]);
            }
            return trimmed.toLowerCase();
        }
        return '';
    };
    const a = extractText(valueA);
    const b = extractText(valueB);
    if (typeof a === 'number' && typeof b === 'number') {
        return a - b;
    }
    return String(a).localeCompare(String(b), undefined, { numeric: true });
};
export const generateDynamicColumns = (checkboxValues, ViewDetailPage, sortedInfo) => {
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    // const defaultWidth = 100;
    let columns = [];
    if (checkboxValues !== undefined) {
        columns = checkboxValues
            .filter((item) => item.isChecked)
            .map((item) => {
                const column = {
                    title: item.name,
                    dataIndex: item.FieldValue,
                    key: item.FieldValue,
                    // width: LeadColumnFields.ColumnWidth[item.FieldValue] || defaultWidth,
                    sortDirections: ['ascend', 'descend'],
                    sortOrder: sortedInfo?.column?.dataIndex === item.FieldValue ? sortedInfo?.order : null,
                    // ellipsis: true,
                };
                switch (item.FieldValue) {
                    case 'name':
                        column.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.name.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    case 'accountname':
                        column.onCell = (record) => ({
                            onClick: (e) => {
                                e.stopPropagation();
                                if (record?.LinkAccount) {
                                    ViewDetailPage(record.accountID, "ACCOUNT")
                                }
                            },
                        });
                        column.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.accountname.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children : '';
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    case 'leadowner':
                        column.onCell = (record) => ({
                            onClick: (e) => {
                                e.stopPropagation();
                                if (Role === "Administrator" || profile.userId === record.userId) {
                                    ViewDetailPage(record.userId, "USER")
                                }
                            },
                        });
                        column.sorter = (a, b) => {
                            const extractNameText = (item) => {
                                const figcaption = item.leadowner.props.children.find(child => child.type === 'figcaption');
                                return figcaption ? figcaption.props.children[0].props.children.trim() : ''; // Extract first div inside figcaption
                            };
                            const valueA = extractNameText(a);
                            const valueB = extractNameText(b);
                            return valueA.localeCompare(valueB);
                        };
                        break;
                    default:
                        column.sorter = (a, b) => {
                            const valueA = a[item.FieldValue]?.props?.children || '';
                            const valueB = b[item.FieldValue]?.props?.children || '';
                            return universalSorter(valueA, valueB, profile);
                        };
                        break;
                }
                return column;
            });
    }
    return columns;
}

export const generateUsersTableData = (exportData) => {
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const usersTableData = [];
    if (exportData && exportData[0] !== "") {
        exportData.forEach((lead, key) => {
            usersTableData.push({
                LinkAccount: lead.accountPermission,
                accountID: lead.accountId,
                LeadDataForPermission: lead,
                SharingData: lead?.sharingPermission?.sharePermission,
                sharingid: lead.fromId,
                userId: lead.lead_owner,
                key: lead.leads_id,
                no: key + 1,
                name: (<div className="user-info_image table_list_clicks">
                    {lead.leads_id && (lead.lead_profile !== null && lead.lead_profile
                        !== undefined && lead.lead_profile !== "" ?
                        <figure>
                            <img style={{ width: "30px", height: "30px" }} src={lead.lead_profile} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag LeadIcon'>
                            {lead.first_name && lead.first_name.slice(0, 1).toUpperCase()}
                        </span>
                    )}
                    {lead.leads_id &&
                        <figcaption>
                            <div>
                                {`${lead.first_name} ${lead.last_name}`}
                            </div>
                            <div className='entityemail'>
                                {lead.primary_email}
                            </div>
                        </figcaption>
                    }
                </div>),
                accountname: (<div className={`user-info_image ${lead.accountPermission && "ListNavigate"}`}>
                    <span className='list_span_Tag AccountIcon'>
                        {lead?.account_name?.slice(0, 1).toUpperCase()}
                    </span>
                    <figcaption>
                        <div>
                            {lead.account_name}
                        </div>
                    </figcaption>
                </div>),
                primaryemail: (<div className='table_list_clicks'>{lead.primary_email}</div>),
                leadstatus: (lead.leads_status_name &&
                    < div className={`table_list_clicks status-text Leadstatus${lead.lead_status_id}`}>{lead.leads_status_name}</div >),
                leadowner: (<div className={`user-info_image ${(Role === "Administrator" || profile.userId === lead.lead_owner) && "ListNavigate"}`}>
                    {lead.lead_owner && (lead.userProfilePic !== null && lead.userProfilePic
                        !== undefined && lead.userProfilePic !== "" ?
                        <figure>
                            <img style={{ width: "30px", height: "30px" }} src={lead.userProfilePic} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag UserIcon'>
                            {lead.userFirstName && lead.userFirstName.slice(0, 1).toUpperCase()}
                        </span>)
                    }
                    {lead.lead_owner &&
                        <figcaption>
                            <div>
                                {`${lead.userFirstName} ${lead.userLastName}`}
                            </div>
                            <div className='entityemail'>
                                {lead.leadOwner}
                            </div>
                        </figcaption>}
                </div>
                ),
                title: (
                    <div
                        className='table_list_clicks'
                    >{lead.title}
                    </div>
                ),
                seniorityLevel: (
                    <div
                        className='table_list_clicks'
                    >{lead.seniority_level}
                    </div>
                ),
                designation: (
                    <div
                        className='table_list_clicks'
                    >{lead.designation}
                    </div>
                ),
                secondaryemail: (
                    <div
                        className='table_list_clicks'
                    >{lead.secondary_email}
                    </div>
                ),
                industry: (<div className='table_list_clicks'>{lead?.industryName}</div>),
                noofemployees: (<div className='table_list_clicks'>{lead?.nom_of_employees}</div>),
                annualrevenue: (<div className='table_list_clicks'>{lead?.annual_revenue}</div>),
                rating: (<div className='table_list_clicks'>{lead?.rating}</div>),
                phone: (
                    <div
                        className='table_list_clicks'
                    >{lead.phone}
                    </div>
                ),
                fax: (
                    <div
                        className='table_list_clicks'
                    >{lead.fax}
                    </div>
                ),
                mobile: (
                    <div
                        className='table_list_clicks'
                    >{lead.mobile}
                    </div>
                ),
                leadsource: (lead.lead_source_name &&
                    <div className='table_list_clicks status-text LeadSource'
                    >{lead.lead_source_name}
                    </div>
                ),
                description: (
                    <div
                        className='table_list_clicks'
                    >
                        {lead.description ? `${lead.description.substring(0, 50)}...` : lead.description}
                    </div>
                ),
                emailoptout: (
                    <div
                        className='table_list_clicks'
                    >{lead.email_opt_out === 0 ? "No" : lead.email_opt_out === 1 && "Yes"}
                    </div>
                ),
                country: (
                    <div
                        className='table_list_clicks'
                    >{lead.country}
                    </div>
                ),
                state: (
                    <div
                        className='table_list_clicks'
                    >{lead.state}
                    </div>
                ),
                city: (
                    <div
                        className='table_list_clicks'
                    >{lead.city}
                    </div>
                ),
                street: (
                    <div
                        className='table_list_clicks'
                    >{lead.street}
                    </div>
                ),
                zipCode: (
                    <div
                        className='table_list_clicks'
                    >{lead.postcode}
                    </div>
                ),
                createdby: (
                    <div className='table_list_clicks'>
                        {lead?.created_at}
                    </div>
                ),
                modifiedby: (
                    <div className='table_list_clicks'>
                        {lead?.modified_at}
                    </div>
                ),
                leadscore: (
                    <div className='table_list_clicks'>
                        {Number(lead?.lead_score)?.toFixed(2)}
                    </div>
                ),
                website: (
                    <div className='table_list_clicks'>
                        {lead?.website}
                    </div>
                ),
                linkedinUrl: (
                    <div className='table_list_clicks'>
                        {lead?.linkedin_url}
                    </div>
                ),
            });
        });
    }

    return usersTableData;
};
